import { Box, Grid } from '@material-ui/core';
import { useParams } from 'react-router-dom';

import { ActionDetailAccordion } from '@/components/modules/OrderActivity/components/ActionDetailAccordion';
import { ActionIcon } from '@/components/modules/OrderActivity/components/ActionIcon';
import { OrderGeneralDetails } from '@/components/modules/OrderActivity/components/OrderGeneralDetails';
import { useCurrentOrderOnParamId } from '@/components/modules/OrderActivity/hooks/useOrderActions/useCurrentOrderOnParamId';
import { PendingDataWarning } from '@/components/shared/components/PendingDataWarning';
import { PendingDataType } from '@/config/types';
import { useSetPageLoadingWhenRequesting } from '@/hooks/requests/useSetPageLoadingWhenRequesting';
import { useCustomTheme } from '@/hooks/useCustomTheme';
import { useScreen } from '@/hooks/useScreen';
import { useSticky } from '@/hooks/useSticky';
import { withPermissionsModule } from '@/utils/withPermissionsModule';

function OrderActivity() {
  const { loanId } = useParams();

  if (!loanId) return null;

  const { palette } = useCustomTheme();
  const { isMobile } = useScreen();
  const { stickyOnDesktopStyle } = useSticky();
  const { actions, orderDetails, loading } = useCurrentOrderOnParamId({ loanId });

  const verticalBarStyle = {
    borderLeft: '1px solid',
    borderColor: palette.grey[300],
    bottom: '-10px',
    marginTop: '-10px',
    position: 'relative',
    height: '100%',
  };
  const finalVerticalBarStyle = {
    borderLeft: '1px solid',
    borderColor: palette.grey[200],
    height: 'calc(100% - 42px)',
  };

  useSetPageLoadingWhenRequesting('ORDER_ACTIVITY', [loading]);

  if (!orderDetails)
    return (
      <>
        <PendingDataWarning type={PendingDataType.ACTIVITY} />
      </>
    );

  return (
    <>
      <Grid container spacing={isMobile ? 6 : 8}>
        <Grid item xs={12} lg={6} style={stickyOnDesktopStyle}>
          {orderDetails && <OrderGeneralDetails orderDetails={orderDetails} />}
        </Grid>
        <Grid item xs={12} lg={6}>
          {actions?.map((action, key) => (
            <Box key={key} display={'flex'}>
              <Box mr={1} mt={'10px'} display={'flex'} flexDirection={'column'} alignItems={'center'}>
                <ActionIcon type={action.type} size={'small'} />
                <Box style={actions.length - 1 > key ? verticalBarStyle : finalVerticalBarStyle} />
              </Box>
              <Box pb={3} flexGrow={1} style={{ paddingBottom: actions.length - 1 > key ? '24px' : 0 }}>
                <ActionDetailAccordion action={action} />
              </Box>
            </Box>
          ))}
        </Grid>
      </Grid>
    </>
  );
}

export const OrderActivityModule = withPermissionsModule(OrderActivity);
